/*!

=========================================================
* Paper Dashboard PRO React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// import ReactDOM from "react-dom/client";
import { createRoot } from 'react-dom/client';
import { Router, Route, Routes, Navigate } from "react-router-dom";
import Sub from "layouts/Sub.jsx";
import AuthLayout from "layouts/Auth.jsx";
import AdminLayout from "layouts/Admin.jsx";
import cookie from 'react-cookies';
import "bootstrap/dist/css/bootstrap.css";
import "assets/scss/paper-dashboard.scss?v=1.1.0";
import "assets/scss/tabs.scss";
import "assets/demo/demo.css";
import { Provider } from 'react-redux'

import ReactRouteAll from './ReactRouteAll';
// import TestApp from './TestApp';

import {store,persistor} from './store/index';

import { PersistGate } from 'redux-persist/integration/react';
import { GoogleOAuthProvider } from '@react-oauth/google';

import "assets/css/designer.css";
import "assets/css/new-custom-style.css";
import "assets/css/r-new-custom-style.css";
import "assets/css/developer-new-custom-style.css";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import "react-notification-alert/dist/animate.css";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { BrowserRouter } from "react-router-dom";
import { SidebarProvider } from "./context/SidebarContext";

// ✅ Install media interceptors to auto-register all getUserMedia and AudioContext
import { installMediaInterceptors } from './util/mediaInterceptor';
installMediaInterceptors();

import { captureUtmParams } from './util/utmTracker';
captureUtmParams();

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
	<GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
		<Provider store = {store}>
			<PersistGate loading={null} persistor={persistor}>
				<BrowserRouter>
				 <SidebarProvider>
				{/* <TestApp /> */}
				<ReactRouteAll/>
        <ToastContainer
          position="top-right"
          autoClose={7000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
				 </SidebarProvider>
				</BrowserRouter>
			</PersistGate>
		</Provider>
	</GoogleOAuthProvider>
);
